import React, { useContext, useEffect, useState } from 'react';

import { Typography, Stack } from '@mui/material';

import { DataContext } from '../../../../context/DataContext';
import { conv2Letras } from '../../../../helpers/n2Letras';

import { getToken } from '../../../../api/Account';
import { simpleMessage, num_Letras } from '../../../../helpers/Helpers';
import { getClientFullAddressAsync } from '../../../../api/Clients';

import { isEmpty } from 'lodash';

import '../../../../components/estilos/estilos.css';
import moment from 'moment';
import { num_to_Letra } from '../../../../helpers/num_Letras';
import { getCreditGarantiasAsync } from '../../../../api/Credits';
import { getTipoCambioDiaAsync } from '../../../../api/TipoCambio';
import { conv2LetrasDolar } from '../../../../helpers/n2LetrasDolar';

export const PrintPagare = React.forwardRef((props, ref) => {
	const [plazoMes, setPlazoMes] = useState(0);
	const [address, setAddress] = useState('');

	const [mes, setMes] = useState('');
	const [garantiaList, setGarantiaList] = useState([]);
	const [tipoCambio, setTipoCambio] = useState(0);

	const {
		title,
		slogan,
		icon,
		setIsLoading,
		setIsUnautorized,
		docTitle,
		representanteLegal,
		nombreLegal,
		ruc,
		cel
	} = useContext(DataContext);

	const {
		id,
		client,
		montoPagar,
		montoEntregado,
		plazo,
		periocidad,
		cuotaPagar,
		fechaEntrega,
		fechaVencimiento,
		fechaPrimeraCuota,
		fechaCreacion,
		destino,
		interesCorriente
	} = props.dataCredit;

	const getPageMargins = () => {
		return `body {
          color:black;
        }`;
	};

	const token = getToken();

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getClientFullAddressAsync(token, client.id);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setAddress(result.data.result);

			await getGarantias();
			await getTipoCambio();

			setIsLoading(false);
		})();
		setPlazoMes((periocidad.cuotaDias * plazo.cuotas) / periocidad.cantidadDias);
		let fecha = new Date(fechaEntrega);

		const monthNameLong = fecha.toLocaleString('es-NI', { month: 'long' });
		setMes(monthNameLong);
	}, []);

	const convertCedula = (cedula) => {
		return num_Letras(cedula);
	};

	const getGarantias = async () => {
		const result = await getCreditGarantiasAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setGarantiaList(result.data.result);
	};

	const getTipoCambio = async () => {
		const result = await getTipoCambioDiaAsync(
			token,
			moment(fechaEntrega).format('YYYY-MM-DD')
		);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setTipoCambio(result.data);
	};

	const getValorGarantias = () => {
		let valor = 0;

		garantiaList.map((item) => (valor += item.valorEstimado));
		return valor;
	};

	return isEmpty(props.dataCredit) ? (
		<></>
	) : (
		<div ref={ref}>
			<style>{getPageMargins()}</style>
			<>
				<Stack direction="row" justifyContent="space-between">
					<img src={icon} style={{ width: 70, height: 70 }} />
					<Stack>
						<Typography variant="h5" color="#212121" textAlign={'center'}>
							{title}
						</Typography>
						<Typography color="#212121" textAlign={'center'}>
							{slogan}
						</Typography>
						<h6>CONTRATO DE CREDITO GARANTIZADO CON GARANTIA MOBILIARIA.</h6>
						{/* <Typography
							variant="h6"
							color="#212121"
							textAlign={'center'}
							fontFamily="Agency FB"
						>
							MUTUO GARANTIZADO CON GARANTIA MOBILIARIA OTORGADO A UNA PERSONA.-
						</Typography> */}
					</Stack>
					<img src={icon} style={{ width: 70, height: 70 }} />
				</Stack>

				<p className="pagareP">
					Nosotros: <strong>{representanteLegal}</strong>, mayor de edad, soltero,
					Comerciante, que sita:{' '}
					<span style={{ textDecoration: 'underline' }}>
						Barrio El Rosario De Donde Fue el Club Edén 3 Cuadras Al Oeste 1 Cuadra Al
						Norte{' '}
					</span>
					en esta Ciudad de Chinandega, Departamento de Chinandega, identificado con
					Cédula número: 081-211190-0014C (cero, ocho, uno, guion, dos, uno, uno, uno,
					nueve, cero, guion, cero, cero, uno, cuatro, letra “C”).- El señor{' '}
					<strong>Nelson Ubaldo Ramos Mayorga</strong>, comparece en nombre y
					representación del negocio comercial llamado <strong>“{nombreLegal}”</strong>{' '}
					denominación que podrá abreviarse como <strong>“{nombreLegal}”</strong> y
					acredita su representación mediante documentos; A) Testimonio Número Siete (07)
					Denominado <strong>“Inscripción de Prestamista”</strong> suscrito en esta ciudad
					de Chinandega, Departamento de Chinandega, a la tres y cuarenta y cinco minutos
					de la tarde del día catorce de marzo del año dos mil veinticuatro (2024), ante
					los oficios notariales de la Licenciada{' '}
					<span style={{ textDecoration: 'underline' }}>
						Jamileth Catalina Meza Sánchez
					</span>{' '}
					, abogada y Notario Público e inscrito como Prestamista bajo la cuenta registral
					<strong>MC-XH944A</strong>, asiento electrónico número{' '}
					<strong>uno (1º).- B)</strong> Testimonio Número Ocho <strong>(08)</strong> ,
					denominado “ Inscripción de Comerciante Individual” suscrito en esta Ciudad de
					Chinandega, Departamento de Chinandega, a las a las diez y quince de la mañana
					del dieciocho de marzo del año dos mil veinticuatro ante los oficio notariales
					de la Licenciada{' '}
					<span style={{ textDecoration: 'underline' }}>
						Jamileth Catalina Meza Sánchez
					</span>{' '}
					, abogada y Notario Público e inscrito como Comerciante Individual bajo la
					cuenta registral <strong>MC-XH944A</strong>, asiento electrónico número{' '}
					<strong>dos (2º)</strong>
					ambos documentos inscritos en el Registro de la Propiedad Inmueble Y Mercantil y
					de Garantías Mobiliarias de este Departamento de Chinandega, quien en lo
					sucesivo de este contrato de crédito se denominara como el{' '}
					<strong style={{ textDecoration: 'underline' }}>ACREEDOR</strong>, y el señor
					(a): {props.clientName} mayor de edad, {client.civilStatus}, Comerciante, y de
					este domicilio con dirección exacta {address}, identificado con Cédula de
					Identidad Número {convertCedula(client.identification)} ({client.identification}
					),quien en lo sucesivo de esta contrato de crédito se denominara como el{' '}
					<strong>DEUDOR</strong> y en la calidad que intervenimos y teniendo a la vista
					los documentos que nos acreditan y nos identifican para la realización de esta
					acto, reconociéndonos nuestra capacidad jurídica y legal para contratar y de
					común acuerdo reconocemos, declaramos el siguiente{' '}
					<strong>CONTRATO DE CREDITO GARANTIZADO CON GARANTIA MOBILIARIA</strong>, lo
					siguiente.-
					<strong>
						Clausula I.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Otorgamiento de Crédito y Destino:
						</span>
					</strong>{' '}
					En este acto el ACREEDOR otorga el presente crédito al{' '}
					<strong>DEUDOR (A) </strong> {props.clientName} hasta por la cantidad de{' '}
					{new Intl.NumberFormat('es-NI', {
						style: 'currency',
						currency: 'NIO'
					}).format(montoEntregado)}{' '}
					en letras {conv2Letras(montoEntregado)}, equivalentes según el tipo de cambio
					oficial del Banco Central de Nicaragua (BCN) que para este día es{' '}
					{new Intl.NumberFormat('es-NI', {
						style: 'currency',
						currency: 'NIO'
					}).format(montoEntregado)}{' '}
					(
					{new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'USD'
					}).format(montoEntregado / tipoCambio)}
					) {conv2LetrasDolar(montoEntregado / tipoCambio)} así mismo el cual será
					destinado para :{destino}.{' '}
					<strong>
						- Clausula II.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Tasa de Interés Corriente:
						</span>
						EL DEUDOR (A)
					</strong>{' '}
					reconoce a favor del <strong>ACREEDOR</strong> , una tasa de interés corriente (
					{interesCorriente.toFixed(2)}%) de ({num_to_Letra(interesCorriente)}) por ciento
					sobre el saldo de principal desde la fecha del desembolso hasta la total
					cancelación.{' '}
					<strong>
						- Clausula III.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Periodo de Vigencia, Lugar, Plazo y Forma de Pago:
						</span>
					</strong>{' '}
					Este contrato de crédito tendrá una vigencia de {plazo.description}, contados a
					partir del día {num_to_Letra(moment(fechaPrimeraCuota).format('DD'))} de{' '}
					{moment(fechaPrimeraCuota).format('MMMM')} del{' '}
					{num_to_Letra(moment(fechaPrimeraCuota).format('YYYY'))}. Venciéndose el día{' '}
					{num_to_Letra(moment(fechaVencimiento).format('DD'))} de{' '}
					{moment(fechaVencimiento).format('MMMM')} del{' '}
					{num_to_Letra(moment(fechaVencimiento).format('YYYY'))} salvo cuando sea
					aplicado el pago anticipado. <strong>EL DEUDOR (A) </strong> realizará el pago
					en efectivo en moneda córdobas, directamente al <strong>ACREEDOR</strong> o en
					el domicilio del negocio del <strong>EL DEUDOR (A) </strong> que sita:{' '}
					<span style={{ textDecoration: 'underline' }}>{address}</span> en esta Ciudad de
					Chinandega, Departamento de Chinandega o podrá realizar transferencia bancaria a
					la cuenta del Banco Financiero Nacional que suministrara{' '}
					<strong> EL ACREEDOR</strong>.{' '}
					<strong>
						- Clausula IV.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Mantenimiento de Valor:
						</span>
					</strong>{' '}
					Conforme lo establecido en el marco regulatorio todas las variaciones de la
					Moneda Nacional (Devaluaciones) con respecto a la moneda de referencia serán
					asumidas por <strong>EL DEUDOR (A) </strong> por ende el riesgo cambiario ha
					sido expresamente aceptado y asumido contractualmente por{' '}
					<strong>EL DEUDOR (A) </strong>.{' '}
					<strong>
						- Clausula V.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Garantía Mobiliaria:
						</span>
					</strong>{' '}
					Que para garantizar el cumplimiento de la obligación contenida en este contrato
					de crédito, especialmente en garantía del pago del principal, así como de los
					intereses corrientes derivado de ausencia u omisión total o parcial de pago por
					el parte de <strong>EL DEUDOR (A) </strong> y de las clausulas estipuladas en
					este contrato; manifiesta <strong>EL DEUDOR (A) </strong> {props.clientName}
					que en su carácter titular de los bienes que se encuentran en su posesión y que
					se detallan a continuación constituyen de manera preferente a favor del{' '}
					<strong>ACREEDOR GARANTIA MOBILIARIA</strong> y conforme los artículos siete
					(7), nueve (9), diecisiete (17) numeral seis (6) de la Ley 936 Ley de Garantías
					Mobiliaria, Publicado en la Gaceta número 200 del veinticinco de octubre del año
					dos mil dieciséis (2016).-{' '}
					{garantiaList.length === 0
						? 'NO HAY GARANTIAS'
						: garantiaList.map((item) => {
								return ` un ${item.articulo} de su propiedad con las siguientes características: marca ${item.marca}, modelo ${item.modelo}, serie ${item.serie}, color ${item.color}, `;
							})}{' '}
					<strong>EL DEUDOR (A) </strong>. {props.clientName} declara y manifiesta por
					medio de este contrato de crédito que los bienes muebles descritos en la
					cláusula quinta, están ubicados en la siguiente dirección; {address} otorgado en
					Garantías Mobiliarias son de su propiedad y tiene un valor de{' '}
					{new Intl.NumberFormat('es-NI', {
						style: 'currency',
						currency: 'NIO'
					}).format(getValorGarantias())}{' '}
					{conv2Letras(getValorGarantias())} <strong>EL DEUDOR (A) </strong> se constituye
					en depositario de los bienes y obligándose a ejercer cuidado razonable sobre los
					bienes y derechos en garantías y preservarlos, evitando su pérdida o deterioro.
					El cuidado razonable implica la obligación de tomar las medidas necesarias para
					preservar el valor de la garantía y los derechos derivados de la misma. La
					garantía mobiliaria tendrá la misma vigencia de este contrato de crédito.
					<strong>
						- Clausula VI.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Vencimiento Anticipado:
						</span>
					</strong>{' '}
					En caso que el <strong>EL DEUDOR (A) </strong> incurra en cualquiera de los
					hechos que adelante se enumeran, <strong>EL ACREEDOR</strong> tendrá derecho
					para declarar el vencimiento anticipado del plazo de la obligación y del total
					del préstamo sin responsabilidad alguna de su parte o para declarar vencido
					anticipadamente el saldo deudor y en consecuencia declarar que los saldos del
					principal, intereses del préstamo son exigibles y pagaderos de inmediatos: a) Si
					el <strong>EL DEUDOR (A) </strong> se retrasa en el pago de una de las cuotas
					establecidas en las respectivas fechas de pago convenido.- b) En general de
					cualquiera de los pactos y obligaciones asumidos por el{' '}
					<strong>EL DEUDOR (A) </strong> en el presente contrato..- c) Si una persona
					natural o jurídica ejecute la acción de embargo de los bienes dado en garantía
					en contra del <strong>EL DEUDOR (A) </strong>.- d) Si ocurriese cualquier
					eventualidad que a juicio del <strong>ACREEDOR</strong> justificase la
					conclusión de que <strong>EL DEUDOR (A) </strong> no se encuentra en condiciones
					con las obligaciones contraídas en los términos de este contrato.{' '}
					<strong>
						- Clausula VII.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Autorización Ante Registro Público de la Propiedad Inmueble y Mercantil
							y de Garantías Mobiliarias:
						</span>{' '}
						EL DEUDOR (A) AUTORIZA
					</strong>{' '}
					y manifiesta su <strong>CONSENTIMIENTO</strong> de su libre y espontánea
					voluntad en este contrato de crédito al <strong>ACREEDOR</strong> para que
					consulte, solicite, gestione, inscriba y retire en nombre del
					<strong>EL DEUDOR (A) </strong> cualquier documentación o información
					concerniente al Libro de Propiedades o a la sección “B” de Propietarios de
					Bienes Inmuebles que exista a nombre de <strong>EL DEUDOR (A) </strong>, para
					garantizar aún más la deuda contraída con el <strong>ACREEDOR</strong>
					<strong>
						- Clausula VIII.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Gastos y Cargos Conexos:
						</span>{' '}
						EL DEUDOR (A)
					</strong>{' '}
					reconoce expresamente; <strong> a) GASTOS LEGALES</strong> de los aranceles de
					Registros de Garantía Mobiliaria de conformidad a lo establecido en Acuerdo
					número 554 de la Corte Suprema de Justicia (CSJ), <strong>b)</strong> además el{' '}
					<strong>EL DEUDOR (A) </strong> se obligan al pago del {num_to_Letra(100)} (100)
					por ciento como recargo de los honorarios legales de la{' '}
					<strong>COBRANZA</strong> del <strong>Abogado Litigante.- c)</strong>En caso de
					que se presente la demanda judicial ante el juez competente{' '}
					<strong>EL DEUDOR (A) </strong>, reconocerá en concepto de costos legales del{' '}
					{num_to_Letra(100)} (100) por ciento sobre la suma demandada.-{' '}
					<strong>
						- Clausula IX.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Autorización de Consulta de Información a Centrales de Riesgo:
						</span>
					</strong>{' '}
					Con la finalidad de prevenir el sobreendeudamiento de los clientes activos y
					prospectos clientes, <strong>EL DEUDOR (A) AUTORIZA </strong> y otorga su
					consentimiento a <strong>ACREEDOR</strong> para que consulte cualquier central
					(es) de riesgos privadas autorizadas por la Superintendencia de Bancos y de
					Otras Instituciones Financieras (SIBOIF) para el suministro de información
					positiva y negativa, los que sustenta el record crediticio y declara en este
					mismo acto que toda la información suministrada al <strong>ACREEDOR</strong>{' '}
					para la solicitud de crédito y/o celebración de esta contrato de crédito es
					verídica.-{' '}
					<strong>
						- Clausula X.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Realización Extrajudicial:
						</span>
					</strong>{' '}
					En caso de incumplimiento de la obligación crediticia contenida en el presente
					contrato, sí solo sí, a decisión de<strong>ACREEDOR</strong> este podrá realizar
					de manera extrajudicial las garantías mobiliarias acá constituidas siguiendo el
					procedimiento de los artículos sesenta y cinco (65) y setenta y tres (73) de la
					Ley 936 Ley de Garantías Mobiliaria; a) Se tramitara en la vía extrajudicial el
					pago de las obligaciones vencidas, la obtención de la posesión y la dación en
					pagos de los bienes otorgados dado en garantías, siempre que no existan entre
					las partes controversias a la exigibilidad del crédito, la cantidad reclamada o
					la entrega de la posesión de los bienes.- b) En caso de incumplimiento de la
					obligación garantizada <strong>ACREEDOR</strong> deberá de requerir el pago para
					que el obligado en el término no mayor de cuarenta y ocho (48) horas contadas a
					partir del requerimiento de pago proceda al pago de la suma liquida.- c) El
					requerimiento de pago al <strong>DEUDOR (A), y/o FIADOR (A) SOLIDARIO</strong>{' '}
					se hará por notario público en la dirección del domicilio del{' '}
					<strong>DEUDOR (A)</strong>.{' '}
					<strong>
						- Clausula XI.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Resolución Alterna de Conflicto:
						</span>
					</strong>{' '}
					<strong>DEUDOR (A) Y EL ACREEDOR</strong>, designan como domicilio de resolución
					alterna de conflicto la ciudad de Chinandega en el Complejo Judicial “María
					Haydee Flores Rivas” que sita de los Talleres del Hogar del Niño 300 Metros al
					Este.
					<strong>
						- Clausula XII.{' '}
						<span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
							Aceptación:
						</span>
					</strong>{' '}
					<strong>DEUDOR (A) Y EL ACREEDOR</strong> acuerdan aceptar las obligaciones
					contenidas en las clausulas precedentes, así como las garantías mobiliarias
					otorgadas a favor de <strong>EL ACREEDOR</strong> constituida en el presente
					contrato los que ratificamos, aceptamos y firmamos en la ciudad de Chinandega,
					Departamento de Chinandega en tres tanto y fuerza probatoria a los{' '}
					{moment(fechaCreacion).format('DD')} días del mes de{' '}
					{moment(fechaCreacion).format('MMMM')} del año dos mil{' '}
					{moment(fechaCreacion).format('YYYY')}. -
				</p>

				<Stack direction={'row'} spacing={2} marginTop={5} justifyContent="space-around">
					<Stack spacing={2} justifyContent="center">
						<hr style={{ borderBlockColor: 'black' }} />

						<Typography textAlign={'center'} color="#212121">
							<strong>EL DEUDOR (A)</strong>
						</Typography>
					</Stack>

					<Stack spacing={2} justifyContent="center">
						<Typography textAlign={'left'} color="#212121" marginTop={15}>
							<strong>ANTE MI: </strong>
						</Typography>
						<Typography textAlign={'center'} color="#212121">
							<strong>ABOGADO Y NOTARIO PÚBLICO</strong>
						</Typography>
					</Stack>

					<Stack spacing={2} justifyContent="center">
						<hr style={{ borderBlockColor: 'black' }} />
						<Typography textAlign={'center'} color="#212121">
							<strong>EL ACREEDOR</strong>
						</Typography>
					</Stack>
				</Stack>
			</>
		</div>
	);
});

export default PrintPagare;
